import React, { useCallback, useEffect, useRef, useState } from "react";
import RupeeIcon from "../../../../icons/RupeeIcon";
import HomeIcon from "../../../../icons/HomeIcon";
import MapPin from "../../../../icons/MapPin";
import WrapperPropertiesCard from "./cards/WrapperPropertiesCard";
import HeadPhoneIcon from "../../../../icons/HeadPhoneIcon";
import CallIcon2 from "../../../../icons/CallIcon2";
import MailIcon from "../../../../icons/MailIcon";
import ArrowInclinedSvg from "../../../../icons/ArrowInclinedSvg";
import GeneralInfoCard from "./cards/GeneralInfoCard";
import { useSelector } from "react-redux";
import {
  // getAllAuctionEvents,
  getAllAuctionEventsCount,
  // getAuctionEventsForBidder,
  getAuctionEventsForBidderHome,
  getBidderByUserUuid,
} from "services";
import { useRouter } from "next/router";
import UpcomingEventTable from "./cards/UpcomingEventTable";
import { DateTime } from "luxon";
import BidderKYCStatusContainer from "./BidderKYCStatusContainer";
import Pusher from "pusher-js";
import { Badge } from "../../../../shadcn/components/ui/badge";
import AuctionLoader from "../auctionFloor/AuctionLoader";
import PropertyDetailsModel from "../allEvents/PropertyDetailsModel";
import UpcomingEventsContainer from "./UpcomingEventsContainer";
import LiveEventsContainer from "./LiveEventsContainer";
import OnboardingWarningBanner from "../onboarding/OnboardingWarningBanner";
import WelcomeHomeForSwissUser from "./WelcomeHomeForSwissUser";

export default function BidderHomePageWrapper() {
  const router = useRouter();
  const [loading, setLoading] = useState(true);
  const [auctionPropertiesCount, setAuctionPropertiesCount] = useState(0);
  const [auctionPropertiesUuids, setAuctionPropertiesUuids] = useState<any>([]);
  const [kycPendingEvents, setKycPendingEvents] = useState([]);
  const [isUserHasUpcomingAuction, setIsUserHasUpcomingAuction] =
    useState<any>(false);
  const [upcomingAuction, setUpcomingAuction] = useState<any>([]);
  const [liveAuction, setLiveAuction] = useState<any>([]);
  const [userAllAuctionEvent, setUserAllAuctionEvent] = useState<any>([]);
  const [isUserHasLiveAuction, setIsUserHasLiveAuction] = useState<any>(false);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const userAllAuctionEventRef = useRef<any>(userAllAuctionEvent);
  const auctionPropertiesRef = useRef<any>({ uuids: [], count: 0 });
  const portalAccessType = useSelector((state: any) => {
    return state.bidderAuth.portalAccessType;
  });
  const onlySwissEventUser = portalAccessType === "swiss";

  const init = async (userUuid: string) => {
    try {
      const [allEventsResult, eligibleBidderResult]: any =
        await Promise.allSettled([
          getAllAuctionEventsCount("accepted"),
          getBidderByUserUuid(userUuid),
        ]);

      if (!onlySwissEventUser && allEventsResult.status === "fulfilled") {
        const allEventsInSystem = allEventsResult.value;
        setAuctionPropertiesCount(allEventsInSystem?.count || 0);
        setAuctionPropertiesUuids(allEventsInSystem?.uuids || []);
        auctionPropertiesRef.current = {
          uuids: allEventsInSystem?.uuids || [],
          count: allEventsInSystem?.count || 0,
        };
      }

      if (eligibleBidderResult.status !== "fulfilled") {
        console.error(
          "Failed to fetch eligible bidder:",
          eligibleBidderResult.reason,
        );
        return;
      }

      const eligibleBidder = eligibleBidderResult.value;

      const eventUuidsForBidder = eligibleBidder.map(
        (item: any) => item.event_uuid,
      );
      const kycPendingEvents = eligibleBidder.filter(
        (item: any) =>
          item?.created_by === "user" &&
          (item?.status === "pending" || item?.status === "rejected"),
      );
      setKycPendingEvents(kycPendingEvents);

      const allEventsForUser: any = await getAuctionEventsForBidderHome(
        eventUuidsForBidder,
        ["accepted", "live"],
      );

      const acceptedEvents = allEventsForUser.filter(
        (e: any) => e.status === "accepted",
      );
      const liveEvents = allEventsForUser.filter(
        (e: any) => e.status === "live",
      );

      // Upcoming auctions (accepted + starting today)
      let upcomingEvents = acceptedEvents;
      let hasUpcomingAuction = false;

      if (acceptedEvents.length > 0) {
        const localNow = DateTime.now().setZone("Asia/Kolkata");

        const todayEvents = acceptedEvents.filter((item: any) => {
          const startDate = DateTime.fromISO(item.start_date_time).setZone(
            "Asia/Kolkata",
          );
          const serverDate = DateTime.fromMillis(item.server_time).setZone(
            "Asia/Kolkata",
          );

          const offset = serverDate.toMillis() - localNow.toMillis();
          const currentTime = localNow.plus({ milliseconds: offset });

          return Math.floor(startDate.diff(currentTime, "days").days) === 0;
        });

        if (todayEvents.length > 0) {
          hasUpcomingAuction = true;
          upcomingEvents = todayEvents;
        }
      }

      setUpcomingAuction(upcomingEvents);
      setIsUserHasUpcomingAuction(hasUpcomingAuction);

      // Live auctions
      setLiveAuction(liveEvents);
      setIsUserHasLiveAuction(liveEvents.length > 0);
      setUserAllAuctionEvent(allEventsForUser);
    } catch (error) {
      console.error("init error: ", error);
    } finally {
      setLoading(false);
    }
  };
  const handleDashBoardUpdate = async (data: any, eventType: string) => {
    if (eventType === "auction_event_has_started") {
      const startedEvent = userAllAuctionEventRef.current.find(
        (event: any) => event.uuid === data?.event_uuid,
      );

      if (startedEvent) {
        // Update the event status in userAllAuctionEvent
        const updatedEvent = { ...startedEvent, status: "live" };
        setUserAllAuctionEvent((prevEvents: any[]) => {
          return prevEvents.map((event: any) =>
            event.uuid === data?.event_uuid ? updatedEvent : event,
          );
        });

        setLiveAuction((prevLiveAuction: any[]) => {
          const isAlreadyLive = prevLiveAuction.some(
            (event: any) => event.uuid === data?.event_uuid,
          );

          if (!isAlreadyLive) {
            const updatedLiveAuction = [...prevLiveAuction, updatedEvent];
            return updatedLiveAuction;
          }
          return prevLiveAuction;
        });

        setUpcomingAuction((prevUpcoming: any[]) => {
          const updatedUpcoming = prevUpcoming.filter(
            (event: any) => event.uuid !== data?.event_uuid,
          );
          const hasUpcoming = updatedUpcoming.length > 0;
          setIsUserHasUpcomingAuction(hasUpcoming);
          return updatedUpcoming;
        });
        setIsUserHasLiveAuction(true);
      }
      const eventFound = auctionPropertiesRef.current.uuids.find(
        (event: any) => event === data?.event_uuid,
      );
      if (eventFound) {
        setAuctionPropertiesUuids((prevUuids: any[]) => {
          const filteredUuids = prevUuids.filter(
            (uuid: any) => uuid !== data?.event_uuid,
          );
          if (!onlySwissEventUser) {
            setAuctionPropertiesCount(filteredUuids.length);
          }
          return filteredUuids;
        });
      }
    }

    if (eventType === "auction_event_has_ended") {
      // Update the event status in userAllAuctionEvent
      setUserAllAuctionEvent((prevEvents: any[]) => {
        return prevEvents.map((event: any) =>
          event.uuid === data?.event_uuid ? { ...event, status: "end" } : event,
        );
      });

      setLiveAuction((prevLiveAuction: any[]) => {
        const updatedLiveAuction = prevLiveAuction.filter(
          (event: any) => event.uuid !== data?.event_uuid,
        );
        setIsUserHasLiveAuction(updatedLiveAuction.length > 0);

        return updatedLiveAuction;
      });
    }
  };

  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });

  useEffect(() => {
    if (user) {
      init(user?.uuid);
    }
  }, [user]);

  useEffect(() => {
    userAllAuctionEventRef.current = userAllAuctionEvent;
    auctionPropertiesRef.current = {
      uuids: auctionPropertiesUuids,
      count: auctionPropertiesCount,
    };
  }, [userAllAuctionEvent, auctionPropertiesUuids, auctionPropertiesCount]);

  ///Pusher for updating the table when event changes
  useEffect(() => {
    Pusher.logToConsole = false;
    const pusher = new Pusher(`${process.env.NEXT_PUBLIC_PUSHER_KEY}`, {
      cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
    });

    const channelId = `update-dashboard`;
    const channel = pusher.subscribe(channelId);

    channel.bind("auction_event_has_started", async (data: any) => {
      if (data) {
        console.log("data:start ", data);
        if (user) {
          await handleDashBoardUpdate(data, "auction_event_has_started");
        }
      }
    });

    channel.bind("auction_event_has_ended", async (data: any) => {
      if (data) {
        console.log("data:end ", data);
        if (user) {
          await handleDashBoardUpdate(data, "auction_event_has_ended");
        }
      }
    });

    pusher.connection.bind("error", function (err: any) {
      if (err?.error?.data?.code === 4004) {
        console.log(">>> detected limit error");
      } else if (err?.data?.code === 1006) {
        // Websocket: CLOSED ABNORMALLY
      }
    });

    pusher.connection.bind("disconnected", function (err: any) {
      console.log(">>> disconnected");
    });

    pusher.connection.bind("connected", function (err: any) {
      console.log("connected", pusher.sessionID);
    });

    return function cleanup() {
      pusher.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const getRangeLabelForAuctionProperties = (number: number) => {
    if (number <= 0) return "0";
    if (number <= 10) return `${number}`;
    if (number < 100) return `${Math.floor(number / 10) * 10}+`;
    if (number < 1000) return `${Math.floor(number / 100) * 100}+`;
    if (number < 100000) return `${Math.floor(number / 1000)}K+`;
    if (number < 10000000) return `${Math.floor(number / 100000)}L+`;
    return `${Math.ceil(number / 10000000)}Cr+`;
  };
  if (onlySwissEventUser) {
    return <WelcomeHomeForSwissUser />;
  }

  return (
    <>
      {loading ? (
        <AuctionLoader type="home" />
      ) : (
        <div>
          {onboardingData && onboardingData?.status !== "active" && (
            <OnboardingWarningBanner />
          )}
          <div className="text-brand-textBlack hidden lg:flex flex-col gap-4">
            <div className="flex flex-col lg:flex-row gap-4 lg:gap-2 xl:gap-4 lg:min-h-[190px] xl:min-h-[230px]">
              <div className="min-w-[200px] w-full bg-white border border-[#EEE]">
                <BidderKYCStatusContainer
                  kycPendingEvents={kycPendingEvents}
                  upcomingAuction={upcomingAuction}
                  liveAuction={liveAuction}
                  userAllAuctionEvent={userAllAuctionEvent}
                />
              </div>
              <div className="hidden lg:flex gap-4 lg:gap-2 xl:gap-4">
                <GeneralInfoCard
                  icon={<HomeIcon />}
                  title="Total properties for auction"
                  mainText={getRangeLabelForAuctionProperties(
                    auctionPropertiesCount,
                  )}
                  buttonIcon={
                    <ArrowInclinedSvg fill="#fff" width={30} height={30} />
                  }
                  styles={{
                    container:
                      "bg-[#F1EAFF] min-w-[175px] mid:min-w-[205px] xl:min-w-[220px]",
                  }}
                  onButtonClick={() => {
                    router.push(`/all-events`);
                  }}
                  onlySwissEventUser={onlySwissEventUser}
                />
                <div className=" bg-white min-w-[190px] mid:min-w-[255px] xl:min-w-[300px] relative">
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center p-3 xl:p-6 min-w-[180px] mid:min-w-[235px] xl:min-w-[240px]">
                    <Badge
                      variant={"default"}
                      className="bg-[#ACE459] font-openSans rounded-sm font-normal text-brand-textBlack py-2 px-2 border-none ml-2 justify-self-center"
                    >
                      <p className="font-openSans text-wrap font-normal text-sm leading-[8px] text-brand-textBlack">
                        Coming Soon
                      </p>
                    </Badge>
                    <div className="text-center text-xs xl:text-sm mt-2">
                      Online Subscription Plans for premium services !
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-4 lg:gap-2 xl:gap-4 lg:min-h-[335px]">
              <div className="xl:min-w-[655px] w-full bg-white border-[#EEE]">
                {!isUserHasUpcomingAuction && !isUserHasLiveAuction && (
                  <UpcomingEventTable />
                )}
                {isUserHasUpcomingAuction && !isUserHasLiveAuction && (
                  <UpcomingEventsContainer
                    setOpen={setOpen}
                    setSelected={setSelected}
                    upcomingAuction={upcomingAuction}
                  />
                )}
                {isUserHasLiveAuction && (
                  <LiveEventsContainer eventData={liveAuction[0]} />
                )}
              </div>
              <div className="min-w-[190px] mid:min-w-[255px] xl:min-w-[300px] bg-white border-[#EEE] p-3 xl:p-6">
                <div>
                  <HeadPhoneIcon width={37} height={37} />
                  <div className="mt-3 w-[130px] text-xs mid:text-sm font-sans text-brand-textBlack">
                    Query about any auction property?
                  </div>
                </div>
                <div className="flex flex-col gap-3 mt-4 mid:mt-10 text-brand-textBlack">
                  <div className="text-xs mid:text-sm">Contact Us</div>
                  <div className="font-sans flex items-center text-[10px] p-1 mid:p-0 mid:text-xs bg-[#F8F8F8]">
                    <MailIcon
                      className="w-6 mid:w-10 h-6 mid:h-10"
                      fill="#F8F8F8"
                      pathFill={"#000"}
                    />
                    <div className="ml-2 break-all">
                      contact@auctionbazaar.com
                    </div>
                  </div>
                  <div className="font-sans flex items-center text-xs p-1 mid:p-0 bg-[#F8F8F8]">
                    <CallIcon2
                      className="w-6 mid:w-10 h-6 mid:h-10"
                      fill="#F8F8F8"
                      pathFill={"#000"}
                    />
                    <div className="ml-2">+91 83709 69696</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-8 lg:hidden">
            {isUserHasLiveAuction && (
              <div className="bg-white">
                <LiveEventsContainer eventData={liveAuction[0]} />
              </div>
            )}

            {isUserHasUpcomingAuction && (
              <UpcomingEventsContainer
                setOpen={setOpen}
                setSelected={setSelected}
                upcomingAuction={upcomingAuction}
              />
            )}

            <div>
              <BidderKYCStatusContainer
                kycPendingEvents={kycPendingEvents}
                upcomingAuction={upcomingAuction}
                liveAuction={liveAuction}
                userAllAuctionEvent={userAllAuctionEvent}
              />
            </div>

            {!isUserHasUpcomingAuction && <UpcomingEventTable />}
            <div className="flex gap-4">
              <div className="bg-white w-full relative">
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center p-3 xl:p-6 min-w-[160px] mobile:min-w-[180px]">
                  <Badge
                    variant={"default"}
                    className="bg-[#ACE459] font-openSans rounded-sm font-normal text-brand-textBlack py-2 px-2 border-none ml-2 justify-self-center"
                  >
                    <p className="font-openSans text-wrap font-normal text-sm leading-[8px] text-brand-textBlack">
                      Coming Soon
                    </p>
                  </Badge>
                  <div className="text-center text-xs xl:text-sm mt-2">
                    Online Subscription Plans for premium services !
                  </div>
                </div>
              </div>
              <GeneralInfoCard
                icon={<HomeIcon />}
                title="Total properties for auction"
                mainText={getRangeLabelForAuctionProperties(
                  auctionPropertiesCount,
                )}
                buttonIcon={
                  <ArrowInclinedSvg fill="#fff" width={30} height={30} />
                }
                styles={{
                  container: " w-full bg-[#F1EAFF] ",
                }}
                onButtonClick={() => {
                  router.push(`/all-events`);
                }}
                onlySwissEventUser={onlySwissEventUser}
              />
            </div>

            <div className="bg-white border-[#EEE] p-3 xl:p-6">
              <div>
                <HeadPhoneIcon width={37} height={37} />
                <div className="mt-3 w-[130px] text-xs mid:text-sm font-sans text-brand-textBlack">
                  Query about any auction property?
                </div>
              </div>
              <div className="flex flex-col gap-3 mt-4 mid:mt-10 text-brand-textBlack">
                <div className="text-xs mid:text-sm">Contact Us</div>
                <div className="font-sans flex items-center text-[10px] p-1 mid:p-0 mid:text-xs bg-[#F8F8F8]">
                  <MailIcon
                    className="w-6 mid:w-10 h-6 mid:h-10"
                    fill="#F8F8F8"
                    pathFill={"#000"}
                  />
                  <div className="ml-2 break-all">
                    contact@auctionbazaar.com
                  </div>
                </div>
                <div className="font-sans flex items-center text-xs p-1 mid:p-0 bg-[#F8F8F8]">
                  <CallIcon2
                    className="w-6 mid:w-10 h-6 mid:h-10"
                    fill="#F8F8F8"
                    pathFill={"#000"}
                  />
                  <div className="ml-2">+91 83709 69696</div>
                </div>
              </div>
            </div>
          </div>
          <PropertyDetailsModel
            open={open}
            setOpen={setOpen}
            selected={selected}
            type="upcoming"
          />
        </div>
      )}
    </>
  );
}
